import { useQuery } from "@tanstack/react-query";
import ManifestsService from "app/data/manifest/manifestsService";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export type ManifestMapMarkerNormalized = {
  lat: number;
  lng: number;
  label?: string;
  description?: string;
};

export function useManifestMapForAssignment(manifestNumber: number | null) {
  return useQuery({
    queryKey: [QUERY_KEYS.PICKUP_ASSIGNMENT_MANIFEST_MAP, manifestNumber],
    queryFn: async () => {
      const res = await ManifestsService.getInstance().getManifestMapData(manifestNumber!);
      if (!res.ok() || !res.data?.result || !res.data?.results) {
        const err = typeof res.getError === "function" ? res.getError() : "Map data unavailable";
        throw new Error(String(err));
      }
      const raw = res.data.results;
      const markers: ManifestMapMarkerNormalized[] = (raw.markers || []).map((mk: any) => ({
        ...mk,
        lat: typeof mk.lat === "string" ? parseFloat(mk.lat) : Number(mk.lat),
        lng: typeof mk.lng === "string" ? parseFloat(mk.lng) : Number(mk.lng),
      }));
      return { markers, polyline: raw.polyline as string | undefined };
    },
    enabled: manifestNumber != null && manifestNumber > 0,
    staleTime: 60_000,
    retry: 1,
  });
}
